import { TimeZoneType } from "../../constants/timezones"
import { NotificationSettingsData } from "../../notifications/notifications"
import { DateOrderOptionType, DateSeparatorOptionType } from "../../utils/date-format"
import { AccountStatus } from "../../types/common"
import { Language } from "../../utils/languages"
import { UserResponse } from "./user-response"

export const makeUserViewModel = (userResponse: UserResponse): UserViewModel => {
  const {
    id,
    createdAt,
    updatedAt,
    firstname,
    lastname,
    fullname,
    initials,
    email,
    accountStatus,
    avatarURL,
    weekendDays,
    firstDayOfWeek,
    timeZone,
    dateFormatSeparator,
    dateFormat,
    notificationSettings,
    language,
  } = userResponse

  const isActive = userResponse.accountStatus === AccountStatus.ACTIVE
  const isWaitingVerification = userResponse.accountStatus === AccountStatus.WAITING_VERIFICATION
  const isDeactivated = userResponse.accountStatus === AccountStatus.DEACTIVATED
  const isHourReportingEnabled = userResponse.featureToggles.enableHourReporting ?? false

  return {
    id,
    createdAt,
    updatedAt,
    firstname,
    lastname,
    fullname,
    initials,
    email,
    accountStatus,
    avatarURL,
    weekendDays,
    firstDayOfWeek,
    timeZone,
    dateFormatSeparator,
    dateFormat,
    notificationSettings,
    language,
    isActive,
    isWaitingVerification,
    isDeactivated,
    isHourReportingEnabled,
  }
}

export type UserViewModel = {
  id: string
  createdAt: string
  updatedAt: string
  firstname: string
  lastname: string
  fullname: string
  initials: string
  email: string
  accountStatus: AccountStatus
  avatarURL: string
  weekendDays: DayOfWeek[]
  firstDayOfWeek: DayOfWeek
  timeZone: TimeZoneType
  dateFormatSeparator: DateSeparatorOptionType
  dateFormat: DateOrderOptionType
  isActive: boolean
  isWaitingVerification: boolean
  isDeactivated: boolean
  language: Language
  notificationSettings: NotificationSettingsData
  isHourReportingEnabled: boolean
}
